import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { setHomeProducts, setLoading, setProductTypes } from "../../redux/product/productSlice";
import api from '../../axios/axios';
import Spinner from "../../utils/Spinner";
const ProductPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const productsDetails = useSelector((state) => state.product.homeProducts);
  const loading = useSelector((state) => state.product.loading);

  const limit = 8;
  const [testProducts, setTestProducts] = useState([]);
  const [zoom, setZoom] = useState({ show: false, x: 0, y: 0, imgSrc: "", productId: null });

  useEffect(() => {
    fetchHome(page, limit);
  }, [dispatch, page, limit]);

  const fetchHome = async (page, limit) => {
    try {
      dispatch(setLoading(true));
      const response = await api.get("user/home", {
        params: {
          page: page, 
          limit: limit
        }
      });
      setTotalPage(response.data.totalPages);
      dispatch(setHomeProducts(response.data.productDetails));
      dispatch(setProductTypes(response.data.productTypes));
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(setLoading(false));
    }
  };


  const handleProductClick = (productType, slugName) => {
    // Navigate to the product details page
    navigate(`/products/${productType}/${slugName}`);
  };
  

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (rating >= i) {
        stars.push(<FaStar key={i} className="text-yellow-500" />);
      } else if (rating >= i - 0.5) {
        stars.push(<FaStarHalfAlt key={i} className="text-yellow-500" />);
      } else {
        stars.push(<FaRegStar key={i} className="text-yellow-500" />);
      }
    }
    return stars;
  };

  const handleMouseMove = (e, imgSrc, productId) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;
    setZoom({ show: true, x, y, imgSrc, productId });
  };

  const handleMouseLeave = () => {
    setZoom({ show: false, x: 0, y: 0, imgSrc: "", productId: null });
  };

  if (loading) return <Spinner/>;
  // if (error) return <p>Error fetching products: {error}</p>;

  return (
    <div className="container mx-auto px-4 lg:px-16 py-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {(productsDetails?.length > 0 ? productsDetails : testProducts).map((product) => (
          <div
            key={product._id}
            className="product-card bg-white p-4 rounded-lg shadow-lg cursor-pointer relative hover:shadow-xl transition-shadow"
            onClick={() => handleProductClick(product?.productType, product?.slugName)}
          >
            {/* Product Image & Zoom */}
            <div
              className="relative w-full overflow-hidden rounded-lg"
              style={{ aspectRatio: "3 / 4" }}
            >
              <div
                className="relative w-full h-full"
                onMouseMove={(e) => handleMouseMove(e, product.mainImage, product._id)}
                onMouseLeave={handleMouseLeave}
              >
                <img
                  src={product.images[0]}
                  alt={product.title}
                  className="w-full h-full object-cover"
                />
                {zoom.show && zoom.imgSrc === product.mainImage && zoom.productId === product._id && (
                  <div
                    className="absolute inset-0 bg-no-repeat"
                    style={{
                      backgroundImage: `url(${zoom.imgSrc})`,
                      backgroundSize: "200%",
                      backgroundPosition: `${zoom.x}% ${zoom.y}%`,
                    }}
                  />
                )}
              </div>
            </div>

            {/* Product Title */}
            <h3 className="font-semibold text-lg mt-2">{product.productName}</h3>

            {/* Rating */}
            <div className="rating text-green-500 mt-1 flex items-center">
              <div className="flex">{renderStars(product.rating)}</div>
              <span className="text-sm text-gray-500 ml-2">({product.reviews} Reviews)</span>
            </div>

            {/* Price */}
            <p className="text-xl font-bold mt-1">${product.price}</p>

            {/* Colors */}
            {product.attributes && product.attributes.length > 0 && (
              <div className="mt-2 flex items-center">
                <span className="text-gray-600 text-sm mr-2">Colors:</span>
                {product.attributes[0].image.map((color, index) => (
                  <img
                    key={index}
                    src={color}
                    alt={`Color ${index + 1}`}
                    className="w-5 h-5 rounded-full border border-gray-300 mr-1"
                  />
                ))}
                {product.moreColors > 0 && (
                  <span className="text-sm text-gray-500 ml-2">+{product.moreColors} more</span>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductPage;
